import React from "react"

//import TopWhiteSwirl from "../assets/SVG/WhiteSwirlTop.svg";
//import TopDarkSwirl from "../assets/SVG/DarkSwirlTop.svg";
//import BottomDarkSwirl from "../assets/SVG/DarkSwirlBottom.svg";
//import BottomWhiteSwirl from "../assets/SVG/WhiteSwirlBottom.svg";
import "../scss/components/swirl-component.scss" 


const SwirlComponent = ({ bgColor, topSwirl, overlaySwirl }) => {
    const overlaySwirlClass = overlaySwirl == true ? "overlay-swirl" : '';
    
    // const topWhiteSwirlStyle = {
    //     backgroundImage: `url(${TopWhiteSwirl})`,
    //     backgroundSize: "cover",
    //     backgroundRepeat: "no-repeat",
    //     backgroundPosition: "top center",
    //     width: "100%",
    //     minHeight: "210px",
    //     position: overlaySwirl == true ?  "absolute" : "relative",
    //     //top: overlayTop,
        
    //   };
    //   const topDarkSwirlStyle = {
    //     backgroundImage: `url(${TopDarkSwirl})`,
    //     backgroundSize: "cover",
    //     backgroundRepeat: "no-repeat",
    //     backgroundPosition: "top center",
    //     width: "100%",
    //     minHeight: "210px",
    //     position: overlaySwirl == true ?  "absolute" : "relative",
    //     //top: overlayTop,
    //   };
    //   const bottomDarkSwirlStyle = {
    //     backgroundImage: `url(${BottomDarkSwirl})`,
    //     backgroundSize: "cover",
    //     backgroundRepeat: "no-repeat",
    //     backgroundPosition: "top center",
    //     width: "100%",
    //     minHeight: "210px",
    //   };
    //   const bottomWhiteSwirlStyle = {
    //     backgroundImage: `url(${BottomWhiteSwirl})`,
    //     backgroundSize: "cover",
    //     backgroundRepeat: "no-repeat",
    //     backgroundPosition: "top center",
    //     width: "100%",
    //     minHeight: "210px",
    //   };

      // if(topSwirl == true){
      //   return(
      //       (bgColor == "White") ? <div className={`swirl-image ${overlaySwirlClass}`} style={topWhiteSwirlStyle}></div> : <div className={`swirl-image ${overlaySwirlClass}`} style={topDarkSwirlStyle}></div>
      //     )
      // }else{
      //   return(
      //       (bgColor == "White") ? <div className="swirl-image" style={bottomWhiteSwirlStyle}></div> : <div className="swirl-image" style={bottomDarkSwirlStyle}></div>
      //   )          
      // }
      if(topSwirl == true){
        //top swirl
        if(bgColor == "White"){
          //white swirl
          return(
            <div className={`swirl-component`}>

                <svg className={`top-swirl ${overlaySwirlClass}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2440 240" preserveAspectRatio="none">
                  <path d="M0,24.3c66.18,24.79,156.3,55.29,265.21,82.57,51.32,12.85,256.42,62.46,535.38,73.32,0,0,279.72,10.89,699.85-50.86,42.34-6.22,157.87-28.64,256.29-43.6,100.16-15.22,181.27-24.53,239.12-30.39,53.36-5.4,110.67-11.12,187.6-14.53,60.32-2.68,111.69-3.01,150.61-2.64,35.31-1.32,70.63-2.64,105.94-3.96v205.79H0V24.3Z" fill="#ffffff"/>
                </svg>

              {/* <img className={`top-swirl ${overlaySwirlClass}`} src={TopWhiteSwirl} alt="Top White Swirl"></img> */}
              
            </div>
          )
        }else{
          //dark swirl
          return(
            <div className={`swirl-component`}>
              {/* <img className={`top-swirl ${overlaySwirlClass}`} src={TopDarkSwirl} alt="Top Dark Swirl"></img> */}
              <svg className={`top-swirl ${overlaySwirlClass}`} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2440 240">
                <path d="M0,24.3c66.18,24.79,156.3,55.29,265.21,82.57,51.32,12.85,256.42,62.46,535.38,73.32,0,0,279.72,10.89,699.85-50.86,42.34-6.22,157.87-28.64,256.29-43.6,100.16-15.22,181.27-24.53,239.12-30.39,53.36-5.4,110.67-11.12,187.6-14.53,60.32-2.68,111.69-3.01,150.61-2.64,35.31-1.32,70.63-2.64,105.94-3.96v205.79H0V24.3Z" fill="#434834"/>
              </svg>
            </div>
          )
        }
      }else{
        //bottom swirl
        if(bgColor == "White"){
          //white swirl
          return(
            <div className="swirl-component">
              {/* <img className="bottom-swirl" src={BottomWhiteSwirl} alt="Bottom White Swirl"></img> */}
              <svg className="bottom-swirl" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2440 91.8">
                <path d="M2.15-.28c260.22,40.35,665.89,88.64,1172.43,91.51,555.05,3.15,996.98-49.56,1267.57-91.51" fill="#ffffff"/>
              </svg>
            </div>
          )
        }else{
          //dark swirl
          return(
            <div className="swirl-component">
              {/* <img className="bottom-swirl" src={BottomDarkSwirl} alt="Bottom Dark Swirl"></img> */}
              <svg className="bottom-swirl" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 2440 91.8">
                <path d="M2.15-.28c260.22,40.35,665.89,88.64,1172.43,91.51,555.05,3.15,996.98-49.56,1267.57-91.51" fill="#434834"/>
              </svg>
            </div>
          )
        }
      }
      
       
}

export default SwirlComponent